import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-success-agreement',
    templateUrl: './success-agreement.component.html',
    styleUrls: ['./success-agreement.component.scss'],
    standalone: false
})
export class SuccessAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
